export const en = {
    action_submit: 'Select',
    company_required: 'Company is required',
    select_company_for: 'Company for',
    company: 'Company',
};
